import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M10.081.265A8.22 8.22 0 0 0 8 0C3.528 0 0 3.528 0 8c0 4.472 3.528 8 8 8 4.472 0 8-3.528 8-8a8.22 8.22 0 0 0-.265-2.081 3.991 3.991 0 0 1-1.832.979c.064.356.097.724.097 1.102 0 3.368-2.632 6-6 6s-6-2.632-6-6 2.632-6 6-6c.378 0 .746.033 1.102.097a3.99 3.99 0 0 1 .98-1.832Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.204 1.165a2.002 2.002 0 0 0 1.012 3.823A2.002 2.002 0 0 0 15 3a2 2 0 0 0-2.796-1.835Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 4a3.97 3.97 0 0 0-4 4c0 2.232 1.768 4 4 4s4-1.768 4-4-1.768-4-4-4ZM6 8c0-1.128.872-2 2-2 1.128 0 2 .872 2 2 0 1.128-.872 2-2 2-1.128 0-2-.872-2-2Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionRadius16 = createIcon(IconComponent);